import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setIsTableReservationModalOpen } from '../../../../redux/modal/modal.actions';
import {
  fetchStore,
  setCheckout,
  setSharedCarts,
  setTable,
  setTableCart,
} from '../../../../redux/store/store.actions';
import { fetchOnAuthenticated } from '../../../../redux/me/me.actions';
import moment from 'moment';
import { notification } from '../../../../utility/notification/notification.service';

const ReservationUpcomingInfoModal = ({
  isOpen,
  closeModal,
  startAt,
  setTable,
  setSharedCarts,
  setCheckout,
  setTableCart,
}) => {
  const now = moment();
  const reservationTime = moment(startAt);
  const difference = reservationTime.diff(now);

  const handleLeaveTable = () => {
    closeModal();
    localStorage.removeItem('tableSession');
    setTable(null);
    setSharedCarts([]);
    setCheckout(null);
    setTableCart(null);
    notification('success', 'leaveTableNotification');
  };

  return (
    <Modal isOpen={isOpen} className="modal-dialog-centered">
      <ModalBody>
        <FormattedMessage
          id="reservationUpcomingInfoText"
          values={{
            minutes: moment.duration(difference).humanize(),
          }}
        />
      </ModalBody>
      <ModalFooter>
        <Button
          onClick={() => closeModal(false)}
          data-testid="test-button"
          color="primary"
        >
          <FormattedMessage id="yesLabel" />
        </Button>
        <Button
          onClick={handleLeaveTable}
          data-testid="test-button"
          color="secondary"
        >
          <FormattedMessage id="noLabel" />
        </Button>
      </ModalFooter>
    </Modal>
  );
};

ReservationUpcomingInfoModal.propTypes = {
  isOpen: PropTypes.bool,
  closeModal: PropTypes.func,
};

const mapStateToProps = (state) => ({
  me: state.me.me,
  store: state.store.store,
});

export default connect(mapStateToProps, {
  setIsTableReservationModalOpen,
  fetchStore,
  fetchOnAuthenticated,
  setTable,
  setTableCart,
  setSharedCarts,
  setCheckout,
})(ReservationUpcomingInfoModal);
